<template>
  <div class="autoOverflow">
    <div class="container">
      <div class="row headerStyle" id="notifHeader">
        <div class="col-4">
          <div class="headerNotifStyle">Notifications</div>
        </div>

        <div class="col-6"></div>

        <div class="col-2 rightAlign">
          <b-button
            class="showAllStyle"
            @click="toggleFilter ? showAllModalOpen() : toggleFilter = true"
            size="sm"
          >{{toggleFilter ? 'Show all' : 'Show current'}}</b-button>
        </div>
      </div>
      <div class="row" v-if="Object.keys(noteShowAval).length == 0 && !loading">
        <div class="col-12" style="height: 30vh; font-size: 32px;color:grey;">
          <p
            style="margin-top: 100px;"
          >{{toggleFilter ? 'No active notifications for now' : 'No notifications found for selected period'}}</p>
        </div>
      </div>

      <div v-if="loading && Object.keys(noteShowAval).length == 0">
        <b-spinner variant="primary" label="Spinning" style="margin-top: 100px;"></b-spinner>
      </div>

      <div class="row commonNotifClass" v-for="(note, nkey) in noteShowAval" :key="nkey">
        <div class="col-12">
          <ClientNotification
            :note="note"
            :notifications="noteData.filter(el => el.ssId == note.ssId)"
            :maId="currAdmin.id"
            :showingActive="toggleFilter"
            :alladmins="alladmins"
            v-on:ProcessStatusChanged="changeProcessingStatus"
            :key="'notif-' + nkey"
          />

          <!-- Ending note -->
          <hr class="divide-line" />
        </div>
      </div>

      <!-- Ending note -->

      <b-modal
        size="lg"
        id="modal-showAll"
        ref="modal-showAll"
        centered
        title="Show all notifications"
        ok-title="Apply"
        :ok-disabled="datePickOkBtn"
        @ok="filterByData()"
      >
        <DatePickerForm v-model="dateFrames" v-on:datePickBtnDisable="datePickOkBtn = $event" />
      </b-modal>
    </div>
  </div>
</template>


<script >
import firebase from "firebase/app";
import DatePickerForm from "./additionalComponents/datePickerForm.vue";
import ClientNotification from "./NotifComponents/ClientNotification.vue";

export default {
  name: "Notifications",
  components: {
    DatePickerForm,
    ClientNotification
  },
  props: {
    currAdmin: Object,
    notifs: Object,
    notifications: Array,
    admins: Array
  },
  data() {
    return {
      alladmins: [],
      loading: false,
      selectedNotifs: {},
      selectidNotifications: [],
      toggleFilter: true,
      datePickOkBtn: true,
      dateFrames: {
        startDate: undefined,
        endDate: undefined
      }
    };
  },

  created() {
    this.makeWindowHeight();
  },

  computed: {
    noteData() {
      let rs = !this.toggleFilter
        ? this.selectedNotifications
        : this.notifications;
      return this.sorting(rs);
    },
    noteShowAval() {
      let r = new Object();
      let nts = !this.toggleFilter ? this.selectedNotifs : this.notifs;
      let ntdatas = !this.toggleFilter
        ? this.selectedNotifications
        : this.notifications;

      for (let ky in nts) {
        let el = nts[ky];
        if (
          (el.processed_status != "processed" &&
            !(
              el.processed_status == "in_process" &&
              el.adminId != this.currAdmin.id
            )) ||
          !this.toggleFilter
        ) {
          r[ky] = el;
        }
      }

      let tmpSort = Object.entries(r).sort((a, b) => {
        let aa = ntdatas.filter(el => el.ssId == a[1].ssId);
        let bb = ntdatas.filter(el => el.ssId == b[1].ssId);
        return aa.length > 0 && bb.length > 0
          ? aa[0].created_time.seconds > bb[0].created_time.seconds
            ? -1
            : bb[0].created_time.seconds > aa[0].created_time.seconds
            ? 1
            : 0
          : 0;
      });

      let rr = new Object();
      for (let k in tmpSort) {
        let el = tmpSort[k];
        rr[el[0]] = el[1];
      }
      return rr;
    }
  },

  watch: {},
  mount() {
    this.loadAllAdimns();
  },

  methods: {
    sorting(arr) {
      return arr.sort((a, b) =>
        a.created_time.seconds > b.created_time.seconds
          ? 1
          : b.created_time.seconds > a.created_time.seconds
          ? -1
          : 0
      );
    },
    loadAllAdimns() {
      let that = this;
      firebase
        .firestore()
        .collection(`admins/${this.currAdmin.location}/adminsInfo`)
        .get()
        .then(function(querySnapshot) {
          if (!querySnapshot.empty) {
            querySnapshot.forEach(function(doc) {
              that.alladmins.push(doc.data());
            });
          }
        })
        .catch(function() {
          // console.log("Error getting documents: ", error);
          that.alladmins = [];
        });
    },

    changeProcessingStatus: function(vl) {
      let updnoteObj = {
        processed_status: vl.status || "active",
        adminId: vl.status != "active" ? this.currAdmin.id : ""
      };

      if (updnoteObj.processed_status == "processed") {
        let processedNotif = this.notifications.find(
          el => el.ssId == vl.ssId && el.note_type == "appointment"
        );
        if (
          processedNotif != undefined &&
          processedNotif.customerId != undefined &&
          processedNotif.customerId != ""
        ) {
          updnoteObj["mode"] = "markEvent";
          updnoteObj["clientId"] = processedNotif.customerId;
          updnoteObj["vehId"] = processedNotif.vehicle.id || "";
        }
      }

      firebase
        .database()
        .ref(`notifications/${this.currAdmin.division}/${vl.ssId}`)
        .update(updnoteObj);

      // if (vl.evRem) {
      //   firebase
      //     .database()
      //     .ref(`eventsToRemove`)
      //     .push()
      //     .set({
      //       event_type: "appointment",
      //       clientId:
      //         this.notifications.find(el => el.ssId == vl.ssId).customerId ||
      //         "",
      //       vehicle:
      //         this.notifications.find(
      //           el => el.ssId == vl.ssId && el.note_type == "appointment"
      //         ).vehicle.id || ""
      //     });
      // }
    },

    filterByData() {
      this.toggleFilter = false;
      this.loading = true;
      this.selectedNotifications = [];
      this.selectedNotifs = {};

      let that = this;
      firebase
        .firestore()
        .collection("Notifications")
        .where("division", "==", `${this.currAdmin.division}`)
        .where(
          "created_time",
          ">=",
          new Date(`${this.dateFrames.startDate}T00:00:01-07:00`)
        )
        .where(
          "created_time",
          "<=",
          new Date(`${this.dateFrames.endDate}T23:59:59-07:00`)
        )
        .get()
        .then(function(querySnapshot) {
          if (!querySnapshot.empty) {
            querySnapshot.forEach(function(doc) {
              let dataInfo = doc.data();
              dataInfo["docID"] = doc.id;
              that.FormNoteDataSelected(dataInfo);
            });
          }
          that.loading = false;
        })
        .catch(function() {
          // console.log("Error getting documents: ", error);
          that.loading = false;
        });
    },

    FormNoteDataSelected(data) {
      this.selectedNotifications.push(data);

      if (this.selectedNotifs[data.ssId] == undefined) {
        this.$set(this.selectedNotifs, data.ssId, {
          adminId: "",
          ssId: data.ssId,
          processed_status: data.processed_status,
          groupDocs: []
        });
      }

      this.selectedNotifs[data.ssId].groupDocs.push(data.docID);
    },

    makeWindowHeight() {
      this.windowHeight = window.innerHeight;
    },

    showAllModalOpen() {
      this.$refs["modal-showAll"].show();
    }
  }
};
</script>


<style>
.headerStyle {
  height: 44px;
  background-color: #b9b3b35d;
}
.showAllStyle {
  padding: 0px 10px;
  /* line-height: 20px; */
  margin: 9px 0px;
}
.rightAlign {
  text-align: right;
}
.headerNotifStyle {
  line-height: 44px;
  font-size: 24px;
  text-align: left;
  font-weight: bold;
}
.card-header {
  font-weight: bold;
}
.autoOverflow {
  height: 92vh;
  width: 100%;
  overflow-y: auto;
  resize: vertical;
}

.commonNotifClass {
  padding: 20px;
}
hr.divide-line {
  height: 12px;
  margin-top: 1.5rem;
  border: 0;
  box-shadow: inset 0 12px 12px -12px rgba(0, 0, 0, 0.5);
}
.btn-outline-primary {
  color: #266db3;
  border-color: #266db3;
}

.btn-outline-primary:hover {
  color: #fff;
  background-color: #266db3;
  border-color: #266db3;
}

#notifHeader select {
  background: #6c757d;
  color: white;
  border: 0;
  width: fit-content;
  font-weight: bold;
  cursor: pointer;
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 0px 15px;
  height: 1.8rem;
  margin-top: 3px;
}

@media (min-width: 576px) and (max-width: 992px) {
  .container,
  .container-md,
  .container-sm {
    max-width: 100%;
  }
}
</style>